import { apiClient } from '../utils/api';

export async function getEstimate(text_id) {
  return await apiClient.GET(`api/estimates/${text_id}`);
}